import GameActionTypes from "./types"
import constants from "../../lib/constants"
import {
  currentStep as getCurrentStep,
  findForeplayStepByIndex,
} from "../../lib/helper"

const INITIAL_STATE = {
  gameIdentifier: "",
  currentGame: {
    game_id: null,
    identifier: "",
    gameStage: {},
    gameState: {},
    currentStep: {},
    players: [],
    answerStats: [],
    foreplayStats: [],
    showResults: false,
    showForeplayResults: false,
    presentingForeplay: false,
    presentingGame: false,
    currentForeplayIndex: 0,
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GameActionTypes.GAME_UPDATE:
      return {
        ...state,
        [action.payload.prop]: action.payload.value,
      }

    case GameActionTypes.GAME_CHANGE_REVEALED_FLAG:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          currentStep: {
            ...state.currentGame.currentStep,
            question: {
              ...state.currentGame.currentStep.question,
              revealed: action.payload,
            },
          },
        },
      }

    case GameActionTypes.GAME_UPDATE_LOG:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          currentStep: {
            ...state.currentGame.currentStep,
            question: {
              ...state.currentGame.currentStep.question,
              log: action.payload.payload,
            },
          },
        },
      }

    case GameActionTypes.REFRESH_PLAYER_LIST:
      const { players, player, action: playerAction } = action.payload
      let updatedPlayers = state.currentGame.players

      // Sync the full players array
      if (players) {
        return {
          ...state,
          currentGame: {
            ...state.currentGame,
            players,
          },
        }
      }

      // Sync one player
      // Join
      if (playerAction === "join") {
        const playerIndex = updatedPlayers.findIndex(
          (p) => p.user_id === player.user_id
        )

        if (playerIndex >= 0) {
          updatedPlayers[playerIndex] = player
        } else {
          updatedPlayers = [
            ...updatedPlayers,
            player,
          ]
        }
      }
      // Leave
      if (playerAction === "leave") {
        updatedPlayers.filter((p) => p.user_id !== player.user_id)
      }

      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          players: updatedPlayers,
        },
      }

    case GameActionTypes.GAME_ON_ANSWER_STATS_RESET:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          showResults: false,
          answerStats: [],
          currentStep: {
            ...state.currentGame.currentStep,
            question: {
              ...state.currentGame.currentStep.question,
              revealed: 0,
              log: action.payload,
            },
          },
        },
      }

    case GameActionTypes.GAME_JUMP_FOREPLAY:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          currentForeplayIndex: state.currentGame.currentForeplayIndex + 1,
          currentStep: findForeplayStepByIndex(
            state.currentGame.gameStage,
            state.currentGame.currentForeplayIndex + 1
          ),
        },
      }

    case GameActionTypes.GAME_CHANGE_FOREPLAY_INDEX:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          currentForeplayIndex: action.index,
          currentStep: findForeplayStepByIndex(
            state.currentGame.gameStage,
            action.index
          ),
          gameState: {
            ...state.currentGame.gameState,
            foreplay: {
              step: {
                index: action.index,
              },
            },
          },
        },
      }

    case GameActionTypes.JOIN_GAME_SUCCESS: {
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          ...action.payload,
        },
      }
    }

    case GameActionTypes.JOIN_GAME_FAILURE:
      return {
        ...state,
        currentGame: INITIAL_STATE.currentGame,
      }

    case GameActionTypes.REFRESH_GAME_STATS:
      const { answers = [], isUpdate = false } = action.payload

      // Sync all the answers
      if (!isUpdate) {
        return {
          ...state,
          currentGame: {
            ...state.currentGame,
            answerStats: answers,
          },
        }
      }

      // Sync one answer
      let submissions = state.currentGame.answerStats
      answers.forEach((answer) => {
        const submissionIndex = submissions.findIndex((s) => s.submission_id === answer.submission_id);

        if (submissionIndex >= 0) {
          submissions[submissionIndex] = answer;
        } else {
          submissions = [...submissions, answer];
        }
      });

      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          answerStats: [...submissions],
        },
      };

    case GameActionTypes.REFRESH_GAME:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          // Refresh answers
          answerStats: action.payload.answers
            ? action.payload.answers
            : state.currentGame.answerStats,
          // Refresh gameState
          gameState: {
            ...state.currentGame.gameState,
            game: action.payload.currentState,
          },
          // Refresh the currentStep
          currentStep: getCurrentStep(
            { game: action.payload.currentState },
            state.currentGame.gameStage
          ),
        },
      }

    case GameActionTypes.REFRESH_FOREPLAY_STATS:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          foreplayStats: action.payload,
        },
      }

    case GameActionTypes.GAME_UPDATE_SHOW_RESULTS:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          showResults: action.payload,
          currentStep: {
            ...state.currentGame.currentStep,
            question: {
              ...state.currentGame.currentStep.question,
              revealed: 1,
            },
          },
        },
      }

    case GameActionTypes.GAME_UPDATE_SHOW_FOREPLAY_RESULTS:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          showForeplayResults: action.payload,
          currentForeplayIndex: 1,
          currentStep: findForeplayStepByIndex(state.currentGame.gameStage, 1),
        },
      }

    case GameActionTypes.GAME_CLEAN_STATE:
      return {
        ...INITIAL_STATE,
      }

    case GameActionTypes.GAME_ENABLE_FOREPLAY:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          presentingForeplay: true,
        },
      }

    case GameActionTypes.GAME_DISABLE_FOREPLAY:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          currentForeplayIndex: 0,
          currentStep: findForeplayStepByIndex(state.currentGame.gameStage, 0),
          presentingForeplay: false,
        },
      }

    case GameActionTypes.GAME_ENABLE_GAME:
      return {
        ...state,
        currentGame: {
          ...state.currentGame,
          presentingGame: true,
          gameState: {
            ...state.currentGame.gameState,
            game_stage_id: constants.GAME_STAGE_RUNNING,
          },
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/entities/game/reducers.js